import styles from './style.module.css'

const Container = (props) => {
    const { maxWidth = 'max-w-6xl' } = props

    return (
        <div className={`${styles.container} ${maxWidth}`}>
            {props.children}
        </div>
    )
}

export default Container
